import Gallery3D from "./Gallery3D"

export default Gallery3D
